import { useCallback, useState } from 'react'
import { getCustomerAddressValidationError } from './booking-details-step.domain'

/** The address is PII: unlike name, phone and email it is never persisted to `localStorage`. */
export function useCustomerAddressField(isRequired: boolean) {
  const [value, setValue] = useState('')
  const [error, setError] = useState<string | null>(null)

  const handleChange = useCallback((next: string) => {
    setValue(next)
    setError(null)
  }, [])

  const handleBlur = useCallback(() => {
    setError(getCustomerAddressValidationError(value))
  }, [value])

  const validate = useCallback((): boolean => {
    if (!isRequired) return true
    const nextError = getCustomerAddressValidationError(value)
    setError(nextError)
    return !nextError
  }, [isRequired, value])

  return {
    isRequired,
    value,
    error,
    submittedValue: isRequired ? value.trim() : undefined,
    handleChange,
    handleBlur,
    validate,
  }
}
